import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { useIntl } from 'react-intl';
import { PictureGrid } from './PictureGrid';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

export const PicturesCell: FC<WidgetProps> = ({ activityId, activityName, widget }) => {
	const { setDrawerWithoutPrevParams } = useDrawerContext();
	const intl = useIntl();
	const [editMode, setEditMode] = useState(false);

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.pictures.type}
			showEditOnHover
			handleEditAction={() => {
				setDrawerWithoutPrevParams('editPictures', { activityId }, () => setEditMode(false));
				setEditMode(true);
			}}
			editMode={editMode}
			tooltipText={intl.formatMessage({ id: 'journey.detail.widget.edit' })}
		>
			{widget.pictures.length > 0 && <PictureGrid widget={widget} />}
		</WidgetCell>
	);
};
